import React, { useContext, useState } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import ConfirmationModal from '../../../../../../Popup/ConfirmationModal';
import { Url } from '@wix/da-url';
import CoreUpgradeIndicator from '@wix/da-ds/pkg/Indicators/CoreUpgrade';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { useMMDispatch } from '../../../../../_hocs/withOwnReduxStore';
import { convertGallery } from '../../../../../actions';
import s from './PremiumContent.scss';
const PremiumContent = ()=>{
    const { t } = useTranslation();
    const dispatchMM = useMMDispatch();
    const { hasCoreMembership } = useContext(SessionContext);
    const [showPremiumGalleryConversion, setShowPremiumGalleryConversion] = useState(false);
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: s['premium-gallery-form']
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: s['premium-gallery-label']
    }, t('mediapopup.gallections.input.premium_gallery')), /*#__PURE__*/ React.createElement("div", {
        className: s['premium-gallery-subtitle']
    }, t('mediapopup.gallections.input.premium_gallery.subtitle'))), /*#__PURE__*/ React.createElement(MainToggle, {
        className: s['premium-gallery-toggle'],
        variant: "main",
        value: showPremiumGalleryConversion,
        onChange: setShowPremiumGalleryConversion,
        hasAccessibleLabel: true,
        size: "medium",
        type: "button"
    })), /*#__PURE__*/ React.createElement("div", {
        className: c(s['premium-gallery-options'], showPremiumGalleryConversion && s['premium-gallery-options-visible'])
    }, !hasCoreMembership && /*#__PURE__*/ React.createElement("div", {
        className: s['premium-gallery-upsell']
    }, t('mediapopup.gallections.gallery.paid.upgrade'), /*#__PURE__*/ React.createElement("a", {
        href: Url.coreMembershipLink()
    }, /*#__PURE__*/ React.createElement(CoreUpgradeIndicator, {
        className: s['premium-gallery-upsell-button']
    }, t('deviationSubmit.modals.coreMonetizationUpsell.cta'))))), showPremiumGalleryConversion && hasCoreMembership && /*#__PURE__*/ React.createElement(ConfirmationModal, {
        title: t(`mediapopup.gallections.input.premium_gallery.modal.title`),
        text: /*#__PURE__*/ React.createElement("div", null, t('mediapopup.gallections.input.premium_gallery.modal.text')),
        confirmBtnLabel: t(`mediapopup.gallections.input.premium_gallery.modal.confirm`),
        useTransparentOverlay: false,
        cancelBtnLabel: t('common.cancel'),
        confirmBtnType: 'default',
        onConfirm: ()=>dispatchMM(convertGallery()),
        onCancel: ()=>setShowPremiumGalleryConversion(false),
        onRequestClose: ()=>setShowPremiumGalleryConversion(false),
        isOpen: showPremiumGalleryConversion
    }));
};
PremiumContent.displayName = 'PriceField';
export default PremiumContent;

//# sourceMappingURL=PremiumContent.js.map